// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CalendarController from "./calendar_controller"
import CalendarPopulateController from "./calendar_populate_controller"
import ColorPickerController from "./color_picker_controller"
import EventFormController from "./event_form_controller"
import EventImageController from "./event_image_controller"
import FilterController from "./filter_controller"
import HelloController from "./hello_controller"
import RecurrenceFormController from "./recurrence_form_controller"
import ToastController from "./toast_controller"

application.register("calendar", CalendarController)
application.register("calendar-populate", CalendarPopulateController)
application.register("color-picker", ColorPickerController)
application.register("event-form", EventFormController)
application.register("event-image", EventImageController)
application.register("filter", FilterController)
application.register("hello", HelloController)
application.register("recurrence-form", RecurrenceFormController)
application.register("toast", ToastController)
